<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && (roleSer.accessData.viewAllowed || roleSer.accessData.insertAllowed)">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <h1>{{'test.heading' | translate}}</h1>
        <!-- <div (mouseover)="onTrainingIcon(videoAssetGroups.TestManagement)">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
            </div>
          </ng-container>
        </div> -->
      </div>

      <div class="itemBtn">

        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-warn" (click)="createNewTest()" aria-label="Add New Item"
              [disabled]="(roleSer.accessData? !roleSer.accessData.insertAllowed :true || roleSer.accessData? !roleSer.accessData.updateAllowed :true)">
              + {{'test.btnNew' | translate}}</button>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'test.labelName' | translate}}" [(ngModel)]="testName"
            class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'test.labelDesc' | translate}}" [(ngModel)]="testDescription"
            class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Description">
          </div>
          <div class="input-wrapper invalid">
            <input type="text" placeholder="{{'test.labelTag' | translate}}" [(ngModel)]="itemTag"
            class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="" filterValidator="Name">
          </div>
          <div class="input-wrapper ">
            <select aria-placeholder="Status" [(ngModel)]="testStatus" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="">{{'test.labelStatus' | translate}}</option>
              <option *ngFor="let statusList of testStatusList" value="{{ statusList.itemStatusId }}">
                {{ statusList.itemStatus }}
              </option>
            </select>
          </div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" (click)="testFilter()" aria-label="Search"
              [disabled]="(roleSer.accessData? !roleSer.accessData.viewAllowed :true)">{{'test.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" (click)="resetFilter()" aria-label="Reset"
              [disabled]="(roleSer.accessData? !roleSer.accessData.viewAllowed :true)">{{'test.btnReset' | translate}}</button>
          </div>
        </div>
      </div>
      <div *ngIf="isNoTest" class="data-not-found-container table-container">
        <span>{{'test.noTestMsg' | translate}}</span>
      </div>


      <div *ngIf="!isNoTest">
        <div class="table-container">
          <table mat-table [dataSource]="tests" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="itemBankName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">
                <ng-container *ngIf="row?.testName?.length > 40; then sliceTitle; else noSlice ">
                </ng-container>
                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row?.testName}}" matTooltipPosition="above">
                    {{ row?.testName | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSlice>
                  <div class="text-bold">{{ row?.testName }}</div>
                </ng-template>

                <ng-container *ngIf="row?.testDescription?.length > 40; then sliceDesc; else noSliceDesc">
                </ng-container>
                <ng-template #sliceDesc>
                  <div class="test-desc" matTooltip="{{row?.testDescription}}" matTooltipClass="my-custom-tooltip" matTooltipPosition="above">
                    {{ row?.testDescription | slice: 0:40 }}...</div>
                </ng-template>
                <ng-template #noSliceDesc>
                  <div class="test-desc"> {{ row?.testDescription }} </div>
                </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="itemCount">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">{{ row.itemCount }}</td>
            </ng-container>
            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">{{ row.duration }}</td>
            </ng-container>
            <ng-container matColumnDef="Scoringtype">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column4' | translate}}</th>
              <!-- <td mat-cell *matCellDef="let row">
                {{row.scoringTypeId == 1 ? ScoringTypeNameEnum.OnQuestion : row.scoringTypeId == 3 ? ScoringTypeNameEnum.On180360Degree :
                ScoringTypeNameEnum.OnOption}}
              </td> -->
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">
                {{row.scoringTypeId == 1 ? ('test.questionScoring' | translate) : row.scoringTypeId == 3 ? ('test.DICSStyle' | translate) :
                ('test.optionScoring' | translate)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="itemStatus">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">
                <!-- <i *ngIf="row?.statusName === 'Published'" class="fa fas fa-circle publish"
                matTooltip="Published">
              </i>-->
                <span *ngIf="row?.statusName === 'Published'" class="fa fas fa-circle publish"
                  matTooltip="{{'test.statusTooltip.published' | translate}}" matTooltipPosition="above">
                </span>
                <span *ngIf="row?.statusName === 'Unpublished'" class="glyphicon glyphicon-adjust unpublish"
                  matTooltip="{{'test.statusTooltip.unPublished' | translate}}" matTooltipPosition="above">
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> {{'test.column6' | translate}} </th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">
                <div class="text-bold"> {{row.modifiedByUser}} </div>
                <div> {{ row.updated | dateAgo }} </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'test.column7' | translate}}</th>
              <td mat-cell *matCellDef="let row" (click)="navigateToItemDetails(row?.testuuId,row?.testId, row?.scoringTypeId)">
                <ng-container *ngIf="row.tagdescriptionString?.length > 40; then sliceTitle; else noSlice ">
                </ng-container>

                <ng-template #sliceTitle>
                  <div matTooltipClass="my-custom-tooltip" matTooltip="{{row?.tagdescription}}" matTooltipPosition="above" class="description-text">
                    <span [innerHtml]="(row.tagdescription | boldTag)"></span>
                  </div>
                </ng-template>
                <ng-template #noSlice>
                  <span [innerHtml]="(row.tagdescription | boldTag)"></span>
                </ng-template>
                <!-- <span [innerHtml]="(row.tagdescription | boldTag)"></span> -->
              </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="action">{{'test.column8' | translate}}</th>
              <td mat-cell *matCellDef="let row" class="action">
                <button mat-icon-button (click)="(currentUserData.userRolesCollections[0].rolesAssigned != 'Account Admin' || row.statusId === 1) ? '' : deleteItem(row)"
                [ngClass]="{'disableIcon': currentUserData.userRolesCollections[0].rolesAssigned != 'Account Admin' || row.statusId === 1}"
                matTooltip="{{'itemDetails.TabQuestions.itemTable.delete' | translate}}">
                  <mat-icon>delete_outline</mat-icon>
                </button>
                <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item>
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                </mat-menu> -->
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns">
            </tr>
          </table>
          <div class="data-not-found-container" *ngIf="noDataFound">
            <p>{{'test.errorMsg' | translate}}</p>
          </div>
        </div>
        <div class="test-paginator" [ngClass]="{'hidden': showPaginator === false}">
          <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
